import './TextToApplyWidget.scss';

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Box from 'components/Box';
import { Detail } from 'components/Text';

import cxHelpers from 'util/className';
import { toI18n } from 'util/i18n';

import PromoteJobWidget from '../PromoteJobWidget';

@cxHelpers('TextToApplyWidget')
export default class TextToApplyWidget extends PureComponent {
  static propTypes = {
    textToApplyNumber: PropTypes.string.isRequired,
    textToApplyCode: PropTypes.string.isRequired,
  };

  renderNumberSection = (copy, numberOrCode) => (
    <div>
      <Detail>{copy}</Detail>
      <div className={this.cxEl('number')}>
        <strong>{numberOrCode}</strong>
      </div>
    </div>
  );

  render() {
    const { textToApplyNumber, textToApplyCode } = this.props;

    return (
      <PromoteJobWidget
        className={this.cx()}
        image="text-to-apply.png"
        header={toI18n('hiring.promote.text_to_apply.header')}
        subheader={toI18n('hiring.promote.text_to_apply.subheader')}
      >
        <Box
          vcenter
          bg="white"
          bb
          bradius
          spacearound
          pas
          tcenter
          className={this.cxEl('number-wrapper')}
        >
          {this.renderNumberSection(
            toI18n('hiring.promote.text_to_apply.text_number'),
            textToApplyNumber
          )}
          {this.renderNumberSection(
            toI18n('hiring.promote.text_to_apply.with_code'),
            textToApplyCode
          )}
        </Box>
      </PromoteJobWidget>
    );
  }
}
